import { MenuButton } from '@frameio/vapor';
import { IconPrimaryNavDevFlagFill } from '@frameio/vapor-icons';
import { useAppSheetButton } from '../../../hooks';
import TEXT from './generated/TEXT/DevToolsMenuItem';

TEXT.DEFINE({
  /** Help and support menu item label */
  label: 'DevTools',
});

const sheetId = 'dev-tools';

export const DevToolsMenuItem = () => {
  const { props: bind } = useAppSheetButton(sheetId);

  return (
    <MenuButton
      iconBefore={<IconPrimaryNavDevFlagFill />}
      {...bind}
      aria-controls="app-sheet"
      aria-expanded={bind['aria-expanded']}
    >
      {TEXT.label}
    </MenuButton>
  );
};
